import {Card, DataStatus, showNotification, Switch} from 'platform/components';

import {useGetTenantSettingValuesQuery, useSetTenantSettingValueMutation} from '@dms/api/settings';
import {i18n} from '@dms/i18n';
import {handleApiError, usePermissions} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

const COPY_REAL_COSTS_TO_EXPECTED_SETTING_ID = 'sale_vehicle-copy_real_costs_to_expected';

export function CopyRealCostsToExpectedSwitch(props: TestIdProps) {
  const [canSetFinanceSettings] = usePermissions({permissionKeys: ['setFinanceSettings']});

  const {data, isLoading, isError} = useGetTenantSettingValuesQuery({
    settingId: COPY_REAL_COSTS_TO_EXPECTED_SETTING_ID,
  });
  const [setTenantSettingValue, {isLoading: isSaving}] = useSetTenantSettingValueMutation();

  // The tenant GET returns the stored records; an empty list means the default, which is off.
  const isEnabled = data?.[0]?.value === true;

  const handleChange = (value: boolean) =>
    setTenantSettingValue({
      settingId: COPY_REAL_COSTS_TO_EXPECTED_SETTING_ID,
      valueRequestBody: {value, force: false},
    })
      .unwrap()
      .then(() => showNotification.success())
      .catch(handleApiError);

  return (
    <Card title={i18n.t('entity.vehicle.labels.expectedCost')} data-testid={props['data-testid']}>
      <DataStatus isError={isError}>
        <Switch
          label={i18n.t('page.settings.copyRealCostsToExpected.label')}
          helperText={i18n.t('page.settings.copyRealCostsToExpected.helperText')}
          value={isEnabled}
          isLoading={isLoading || isSaving}
          isDisabled={!canSetFinanceSettings}
          onChange={handleChange}
          data-testid={suffixTestId('switch', props)}
        />
      </DataStatus>
    </Card>
  );
}
